import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import {
  CellClickedEvent,
  ColDef,
  ICellRendererParams,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Paper } from "@mui/material";
import { EditAndDeleteButtons } from "../../../../shared/data-entries/EditAndDeleteButtons";

interface PlugData {
  PlugStart: string;
  PlugEnd: string;
  PlugHeats: number;
  PlugInsideTime: number;
  PlugOutsideTime: number;
  PlugChangeId?: number;
}

interface DetailCellRendererProps {
  data: { Plugs?: PlugData[] };
  onDetailCellClick: (data: {
    PlugStart: string;
    PlugChangeId?: number;
  }) => void;
  deletePlug: (plugId: number) => void;
  editPlug: (plugId: number) => void;
}

export const DetailCellRenderer = ({
  data,
  onDetailCellClick,
  deletePlug,
  editPlug,
}: DetailCellRendererProps): JSX.Element => {
  const rowData = data.Plugs || [];

  const rowHeight = 36;
  const headerHeight = 36;
  const extraPadding = 22;
  const tableHeight = rowData.length * rowHeight + headerHeight + extraPadding;

  const handleDetailCellClick = (params: CellClickedEvent): void => {
    if (params.colDef.field === "PlugStart") {
      onDetailCellClick({
        PlugStart: params.data.PlugStart,
        PlugChangeId: params.data.PlugChangeId,
      });
    }
  };

  const columnDefs: ColDef[] = [
    {
      field: "PlugStart",
      headerName: "Start",
      flex: 1,
      valueFormatter: (params): string =>
        dxtToLocalServerTime(params.value, "MM/dd/yyyy HH:mm"),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "PlugEnd",
      headerName: "End",
      flex: 1,
      valueFormatter: (params): string =>
        dxtToLocalServerTime(params.value, "MM/dd/yyyy HH:mm"),
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "PlugHeats",
      headerName: "Heats",
      flex: 1,
      valueFormatter: (params): string => params.value || "0",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "PlugInsideTime",
      headerName: "Inside Time",
      flex: 1,
      valueFormatter: (params): string =>
        params.value ? `${params.value} min` : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "PlugOutsideTime",
      headerName: "Outside Time",
      flex: 1,
      valueFormatter: (params): string =>
        params.value ? `${params.value} min` : "-",
      cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      field: "actions",
      headerName: " ",
      flex: 1,
      cellRenderer: EditAndDeleteButtons,
      cellRendererParams: (params: ICellRendererParams) => ({
        deleteItem: deletePlug,
        onEdit: editPlug,
        id: (params.data as PlugData).PlugChangeId,
        hide: params.node.rowIndex === 0,
      }),
    },
  ];

  return (
    <>
      <Grid container style={{ backgroundColor: "#dddd" }}>
        <Grid item md={12} xs={12}>
          <Paper
            elevation={5}
            style={{
              padding: 10,
              height: `${tableHeight}px`,
              margin: "10px 30px",
            }}
          >
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={{ sortable: true, resizable: true, flex: 1 }}
              rowData={rowData}
              rowHeight={rowHeight}
              headerHeight={headerHeight}
              suppressHorizontalScroll
              onCellClicked={handleDetailCellClick}
              suppressContextMenu
            />
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};
